<app-navbar title="Słowniki"> </app-navbar>
<app-dynamic-table module="codebook" [haveFilters]="false" [elements]="data" [tableRows]="tableRows">
</app-dynamic-table>
